// extracted by mini-css-extract-plugin
export default {"Wrapper":"TasksMoreFilters_Wrapper__C5P8-","Table":"TasksMoreFilters_Table__KB-3r","Section":"TasksMoreFilters_Section__ZKREm"};